/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupoptions1Inputs */

const en_signupoptions1 = /** @type {(inputs: Signupoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options, one per line`)
};

const de_signupoptions1 = /** @type {(inputs: Signupoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahlmöglichkeiten, eine pro Zeile`)
};

/**
* | output |
* | --- |
* | "Options, one per line" |
*
* @param {Signupoptions1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupoptions1 = /** @type {((inputs?: Signupoptions1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupoptions1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupoptions1(inputs)
	return de_signupoptions1(inputs)
});
export { signupoptions1 as "signupOptions" }